import { CREATE_PDFGENERATOR, GET_CASES_LIST } from '../types'

const INITIAL_STATE = {
  getPDFGenerator: [],
  allCasesList: [],
}

const pdfReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CREATE_PDFGENERATOR:
      return {
        ...state,
        getPDFGenerator: payload.data,
      }
    case GET_CASES_LIST:
      return {
        ...state,
        allCasesList: payload.data,
      }
    default:
      return state
  }
}

export default pdfReducer
